
import {
    GrpcService,
    HttpRequestDelegate,
} from "../grpc"

import {
    FloatValue,
} from "../google/protobuf/wrappers"

export interface ReportDataProcessedNotificationResponse {
}

export interface ReportDataProcessedNotificationRequest {
    ticket: string
}

export interface OrganizationApi {
    organizationId: number /* 组织ID */
    reqUrl: string /* 请求url */
    reqScene: ReqScene /* 使用场景 */
    reqMethod: ReqMethod /* 请求方法 */
    reqParamNameList: Array<string> /* 请求参数名列表 */
    resParamNameList: Array<string> /* 响应参数名列表 */
    resType: ResType /* 响应类型 */
    topicName?: string /* 订阅名 */
    topicTag?: string /* 订阅标签 */
}

export interface ListExamineeByAccountIdResponse {
    examineeList: Array<Examinee>
}

export interface ListExamineeByAccountIdRequest {
    accountId: number
}

export interface Examinee {
    examineeId: number /* 被检测者ID */
    nickname: string /* 昵称 */
    mobileNumber: string /* 联系方式 */
    sex: Sex /* 性别 */
    birthTimestamp?: number /* 出生日期毫秒级时间戳 */
    height: FloatValue /* 身高（cm） */
    weight: FloatValue /* 体重（kg） */
    description?: string /* 描述信息/病征 */
    inPerson?: boolean /* 是否是本人（与accountID对应，注意，一个accountID只能有一个本人信息） */
}

export interface UpdateExamineeRequest {
    examineeId: number
    nickname?: string /* 昵称 */
    sex: Sex /* 性别 */
    birthTimestamp?: number /* 出生日期毫秒级时间戳 */
    mobileNumber?: string /* 手机号 */
    height: FloatValue /* 身高（cm） */
    weight: FloatValue /* 体重（kg） */
    description?: string /* 描述信息/病征 */
    inPerson?: boolean /* 是否是本人（与accountID对应，注意，一个accountID只能有一个本人信息） */
}

export interface AddExamineeResponse {
    examineeId: number
}

export interface AddExamineeRequest {
    nickname?: string /* 姓名 */
    sex: Sex /* 性别「必填」 */
    storeId?: number /* 创建被检测人的店铺ID（只是用于标记在那个组织下创建的检测人） */
    birthTimestamp?: number /* 出生日期毫秒级时间戳 */
    mobileNumber?: string /* 手机号 */
    height: FloatValue /* 身高（cm） */
    weight: FloatValue /* 体重（kg） */
    description?: string /* 描述信息/病征 */
    accountId?: number /* 手机号注册后的accountID「必填」 */
    inPerson: boolean /* 是否是本人（与accountID对应，注意，一个accountID只能有一个本人信息） */
}

export interface SimplifyMeshNotificationResponse {
}

export interface SimplifyMeshNotificationRequest {
    ticket: string /* 报告ticket */
    errCode: number
    errMsg: string
    miniMeshUrl: string /* 简化后的网格模型url */
    payload: string /* 自定义数据 */
}

export interface DeleteInsoleModelRequest {
    ids: Array<number> /* 鞋垫模型ID列表 */
}

export interface AddInsoleModelRequest {
    insoleModelList: Array<NewInsoleModel>
}

export interface NewInsoleModel {
    footSide: FootSide /* 左/右 脚，不能为「FOOT_SIDE_UNKNOWN」 */
    medialLongitudinalArchHigh: MedialLongitudinalArchHigh /* 内足弓高度 */
    medialLongitudinalArchPosition: MedialLongitudinalArchPosition /* 内足弓位置 */
    inEvertion: InEvertion /* 内外翻 */
    length: number /* 鞋垫长度，单位是毫米（mm），不能小于50mm */
    url: string /* 鞋垫模型url */
}

export interface PageListInsoleModelResponse {
    elements: Array<InsoleModel>
    totalElements: number
    totalPages: number
    isFirst: boolean
    isLast: boolean
    number: number
    numberOfElements: number
    size: number
}

export interface PageListInsoleModelRequest {
    pageNum: number /* 页码，默认首页为0 */
    pageSize: number /* 每页数据条数, 默认10条 */
    order: Order /* 排序，默认是按创建时间倒序排序 */
    medialLongitudinalArchHighList: Array<MedialLongitudinalArchHigh> /* 内足弓高度 */
    medialLongitudinalArchPositionList: Array<MedialLongitudinalArchPosition> /* 内足弓位置 */
    inEvertionList: Array<InEvertion> /* 内外翻 */
    footSideList: Array<FootSide> /* 左/右 */
    lengthList: Array<number> /* 鞋垫长度 */
    shoeSizeList: Array<string> /* 对应鞋码 */
}

export interface RegisterResponse {
    accountId: number
}

export interface RegisterRequest {
    countryCode: string
    mobileNumber: string
}

export interface VerifySmsRegisterCaptchaResponse {
    isCorrect: boolean
}

export interface VerifySmsRegisterCaptchaRequest {
    institutionId: number /* 机构ID（在登陆中根据店铺ID获取机构信息接口里有返回） */
    countryCode: string /* 86 */
    mobileNumber: string
    captcha: string
}

export interface SendSmsRegisterCaptchaRequest {
    institutionId: number /* 机构ID（在登陆中根据店铺ID获取机构信息接口里有返回） */
    countryCode: string /* 86 */
    mobileNumber: string
}

export interface ViewReportResponse {
    ticket: string
    state: ProcessingState /* 处理状态 */
    error: ReportError /* 报告错误原因 */
    url: string /* 报告页地址 */
    type: Type /* 报告页类型 */
}

export interface ViewReportRequest {
    ticket: string /* 报告ticket */
}

export interface PageListReportResponse {
    reportList: Array<SimpleReport>
    totalElements: number
    totalPages: number
    isFirst: boolean
    isLast: boolean
    number: number
    numberOfElements: number
    size: number
}

export interface PageListReportRequest {
    pageNum: number
    pageSize: number
    storeIdList: Array<number> /* 店铺组织ID */
    examinationReportIdList: Array<number> /* 报告ID */
    mobileNumberList: Array<string> /* 手机号 */
    nickname: Array<string> /* 用户名称 */
    order: Order /* 默认按创建时间倒序排序 */
    errorList: Array<ReportError> /* 报告异常过滤 */
    serialNumberList: Array<string> /* 设备序列号 */
}

export interface PageListReportAndExamineeRequest {
    pageNum: number
    pageSize: number
    ticketList: Array<string> /* 报告ticket列表 */
    valid?: boolean
    stateList: Array<ProcessingState> /* 处理状态 */
    storeIdList: Array<number> /* 店铺组织ID */
    serialNumber: Array<string> /* 设备序列号 */
    examinerAccountIdList: Array<number>
    examineeAccountIdList: Array<number>
    examinationReportIdList: Array<number>
    mobileNumberList: Array<string> /* 手机号 */
}

export interface PageListReportAndExamineeResponse {
    reportAndExamineeList: Array<ReportAndExaminee>
    totalElements: number
    totalPages: number
    isFirst: boolean
    isLast: boolean
    number: number
    numberOfElements: number
    size: number
}

export interface ReportAndExaminee {
    report: Report /* 报告详情 */
    examinee: Examinee /* 被检测者详情 */
}

export interface UploadReportResponse {
    done: boolean
}

export interface UploadReportRequest {
    storeId?: number /* 登录账号所在的storeId店铺ID */
    serialNumber?: string /* 设备序列号 */
    error: ReportError /* 报告错误类型 */
    ticket?: string /* 报告唯一uuid */
    valid: boolean /* 有效性 */
    code?: string /* 错误码 */
    message?: string /* 错误信息 */
    left: Data /* 左脚数据 */
    right: Data /* 右脚数据 */
    pressureDataUrl?: string /* 足压数据 */
    algorithm3DVersion: string /* 点云融合算法版本 */
    algorithmMeasurementVersion: string /* 测量算法版本 */
}

export interface DeleteReportRemarkRequest {
    ticket: string /* 报告唯一凭证ticket */
}

export interface UpdateReportRemarkRequest {
    ticket: string /* 报告唯一凭证ticket */
    remark: string /* 备注 */
}

export interface AddReportRemarkRequest {
    ticket: string /* 报告唯一凭证ticket */
    remark: string /* 备注 */
}

export interface SendSmsNotificationWhenAccountPreRegistrationRequest {
    countryCode: string
    mobileNumber: string
    organizationType: OrganizationType /* 组织类型，决定了短信通知中跳转地址 */
    name: string /* 收短信人的姓名 */
    organizationName: string /* 组织名称（店铺/机构 名称） */
    username: string /* 账户名（登陆账户，可以是手机号等） */
    initPassword: string /* 初始密码，不传默认「123456」 */
}

export interface OperateResponse {
    done: boolean
}

export interface SendSmsNotificationWhenAccountRegisteredRequest {
    countryCode: string
    mobileNumber: string
    organizationType: OrganizationType /* 组织类型，决定了短信通知中跳转地址 */
    name: string /* 收短信人姓名 */
    organizationName: string /* 组织名称 */
}

export interface ListInsoleModelResponse {
    insoleModelList: Array<InsoleModel>
}

export interface ListInsoleModelRequest {
    medialLongitudinalArchHighList: Array<MedialLongitudinalArchHigh> /* 内足弓高度 */
    medialLongitudinalArchPositionList: Array<MedialLongitudinalArchPosition> /* 内足弓位置 */
    inEvertionList: Array<InEvertion> /* 内外翻 */
    footSideList: Array<FootSide> /* 左/右 */
    lengthList: Array<number> /* 鞋垫长度 */
    shoeSizeList: Array<string> /* 对应鞋码 */
}

export interface RefreshReportRequest {
}

export interface ListReportResponse {
    reportList: Array<SimpleReport>
}

export interface SimpleReport {
    ticket?: string /* 报告唯一uuid */
    state: ProcessingState /* 处理状态 */
    valid: boolean /* 有效性 */
    code?: string /* 错误码 */
    message?: string /* 错误信息 */
    storeId?: number /* 登录账号所在的storeId店铺ID */
    serialNumber?: string /* 设备序列号 */
    examinerAccountId?: number /* 检测者ID */
    examineeAccountId?: number /* 被检测者ID */
    examinationReportId?: number /* 报告ID */
    creationTimestamp: number /* 创建时间 */
    updateTimestamp: number /* 更新时间 */
    remark?: string /* 备注 */
    error: ReportError /* 报告错误原因 */
    store: Store /* 该报告的检测店铺 */
    examinee: Examinee /* 被检测者 */
    examiner: Examiner /* 检测者（店员） */
    examineeId?: number
}

export interface Examiner {
    nickname: string /* 昵称 */
    mobileNumber: string /* 联系方式 */
}

export interface ListReportRequest {
    ticketList: Array<string> /* 报告ticket列表 */
    valid?: boolean
    stateList: Array<ProcessingState> /* 处理状态 */
    storeIdList: Array<number> /* 店铺组织ID */
    serialNumber: Array<string> /* 设备序列号 */
    examinerAccountIdList: Array<number>
    examineeAccountIdList: Array<number>
    examinationReportIdList: Array<number>
}

export interface UpdateReportInsoleModelRequest {
    ticket?: string /* 报告ticket */
    footSide: FootSide /* 左/右脚 */
    insoleModelId?: number /* 模型ID */
}

export interface GetInsoleModelResponse {
    id?: number
    shoeSize?: string
    url?: string
}

export interface InsoleModel {
    medialLongitudinalArchHigh: MedialLongitudinalArchHigh /* 内足弓高度 */
    medialLongitudinalArchPosition: MedialLongitudinalArchPosition /* 内足弓位置 */
    inEvertion: InEvertion /* 内外翻 */
    number: string /* 编号，唯一 */
    footSide: FootSide /* 左/右 */
    length?: number /* 鞋垫长度 */
    url: string
    shoeSize: string /* 对应鞋码 */
}

export interface GetInsoleModelRequest {
    medialLongitudinalArchHigh: MedialLongitudinalArchHigh /* 内足弓高度 */
    medialLongitudinalArchPosition: MedialLongitudinalArchPosition /* 内足弓位置 */
    inEvertion: InEvertion /* 内外翻 */
    footSide: FootSide /* 左/右 */
    length?: number /* 鞋垫长度 */
}

export interface GetExamineeRegisterUrlResponse {
    url: string
}

export interface GenerateReportQRCodeResponse {
    url: string
}

export interface GetExamineeRegisterUrlRequest {
    ticket: string
}

export interface GenerateReportQRCodeRequest {
    ticket: string
}

export interface GetReportExamineeAccountIdByTicketResponse {
    examineeAccountId?: number /* 被检测者accountId， 过期，被examineeId取代 */
    examineeId?: number /* 被检测者ID */
}

export interface GetReportExamineeAccountIdByTicketRequest {
    ticket?: string /* 报告ticket */
}

export interface AddVersionInfoRequest {
    versionInfo: VersionInfo
}

export interface CreateReportRequest {
    ticket?: string /* 报告ticket */
    storeId?: number /* 登录账号所在的storeId店铺ID */
}

export interface ClaimReportResponse {
    url: string
    type: UrlType /* url的类型 */
}

export interface ClaimReportRequest {
    scene: Scene /* 跳转页面路径场景 */
    reportTicket?: string /* 报告ticket */
    institutionId?: number /* 机构ID（在登陆中根据店铺ID获取机构信息接口里有返回） */
}

export interface UpdateVersionInfoRequest {
    versionInfo: VersionInfo
}

export interface GetInstitutionByStoreIdResponse {
    institution: Institution
}

export interface Institution {
    name: string /* 机构名称 */
    description: string /* 机构描述信息 */
    logo?: string /* 机构logo */
    expiredTimestamp?: number /* 过期时间戳（毫秒级） */
    id?: number /* 机构ID */
}

export interface GetInstitutionByStoreIdRequest {
    storeId?: number /* 店铺ID */
}

export interface ListOrganizationLicenceResponse {
    organizationLicenceList: Array<OrganizationLicence>
}

export interface ListOrganizationLicenceRequest {
    organizationIds: Array<number>
}

export interface OperateResult {
    done: boolean
}

export interface UpdateOrganizationLicenceRequest {
    organizationLicence: OrganizationLicence
}

export interface OrganizationLicence {
    organizationId?: number /* 组织ID */
    startTimestamp?: number /* license有效期起始时间 */
    endTimestamp?: number /* license有效期结束时间 */
}

export interface GetLatestVersionInfoByTypeResponse {
    versionInfo: VersionInfo
}

export interface GetLatestVersionInfoByTypeRequest {
    type: VersionType
}

export interface VersionInfo {
    type: VersionType
    version?: string /* 版本号 */
    description?: string /* 描述信息 */
    url?: string /* 下载链接 */
}

export interface ListStoreResponse {
    store: Array<Store>
}

export interface Store {
    name: string /* 店铺名称 */
    description: string /* 店铺描述信息 */
    id: number /* 店铺ID */
    logo?: string /* 店铺logo */
}

export interface ListStoreRequest {
}

export interface GetDeviceInfoResponse {
    status: DeviceStatus
}

export interface GetDeviceInfoRequest {
    deviceSerialNumber?: string
}

export interface CheckReportExamineeExistResponse {
    exist: boolean
}

export interface CheckReportExamineeExistRequest {
    ticket?: string
}

export interface BindingReportExamineeResponse {
    done: boolean
}

export interface BindingReportExamineeRequest {
    ticket?: string
    examineeAccountId?: number /* 过时， 逐步被 examineeId 取代 */
    examineeId?: number /* 被检测人ID */
}

export interface GetCosStsCredentialResponse {
    bucketUrl?: string
    bucket?: string
    region?: string
    keyPrefix?: string
    sessionToken?: string
    tmpSecretId?: string
    tmpSecretKey?: string
    expirationTime?: number
}

export interface GetCosStsCredentialRequest {
    type: CosStsCredentialType /* cos类型 */
    dir?: string /* 将要上传文件的目录，eg：6b04d71b-c974-4828-ac7b-04116f0f370c */
}

export interface DeactiveDeviceInfoResponse {
    done: boolean
}

export interface DeactiveDeviceInfoRequest {
    deviceSerialNumber?: string /* 设备序列号 */
}

export interface ListDeviceInfoByOrganizationIdResponse {
    deviceInfoList: Array<DeviceInfo>
}

export interface ListDeviceInfoByOrganizationIdRequest {
    organizationId?: number
}

export interface DeviceInfo {
    deviceSerialNumber?: string /* 设备序列号 */
    isUsed: boolean /* 是否可 */
    activated: boolean /* 是否被激活 */
}

export interface ActivateResponse {
    done: boolean
}

export interface ActivateRequest {
    code?: string
}

export interface ListActivationCodeInfoByOrganizationIdResponse {
    activationCodeInfoList: Array<ActivationCodeInfo>
}

export interface ActivationCodeInfo {
    code: string /* 激活码 */
    distributorId: number /* 分发器ID */
    receiverId: number /* 接受者ID */
    receiverType: ReceiverType /* 接受者类型 */
    status: ActivationCodeConsumedStatus /* 核销状态 */
    activationTimeStamp?: number /* 激活时间 */
    deviceSerialNumber?: string /* 激活时候带的设备序列号（默认一个激活码对应一个序列号） */
    activationAccountId?: number /* 激活的人 */
    distributeTimestamp?: number /* 激活的人 */
    distributeOrganizationId?: number /* 发放激活码的组织ID */
}

export interface ListActivationCodeInfoByOrganizationIdRequest {
    organizationId?: number
}

export interface GenerateActivationCodeList2OrganizationResponse {
    done: boolean
}

export interface GenerateActivationCodeList2OrganizationRequest {
    distributorId?: number /* 分发器ID */
    receiverId?: number /* 接受者ID */
    receiverType: ReceiverType /* 接受者类型 */
    count: number /* 激活码数量 */
    distributeOrganizationId?: number /* 发放者组织ID */
}

export interface ListLicenseDistributorResponse {
    distributorList: Array<LicenseDistributor>
}

export interface ListLicenseDistributorRequest {
    organizationId?: number
}

export interface CreateLicenseDistributorResponse {
    distributorId: number
}

export interface CreateLicenseDistributorRequest {
    organizationId?: number /* 分发器要发放给的组织的组织ID */
    licensePackageId?: number /* 分发器所属license的ID */
    description?: string /* 描述信息 */
    maximumQuantity?: number /* 可以产生激活码的数量 */
}

export interface LicenseDistributor {
    creatorAccountId?: number /* 创建分发器的人 */
    distributorId?: number /* 分发器ID */
    description?: string
    maximumQuantity?: number /* 最大分发数量 */
    distributedQuantity?: number /* 已经分发的数量 */
    license: License /* 分发器所属license详情 */
}

export interface ListLicenseResponse {
    licenseList: Array<License>
}

export interface ListLicenseRequest {
}

export interface License {
    licensePackageId?: number
    name?: string
    description?: string
    days?: number
}

export interface GetReportByTicketResponse {
    report: Report
}

export interface Report {
    storeId?: number /* 登录账号所在的storeId店铺ID */
    serialNumber?: string /* 设备序列号 */
    state: ProcessingState /* 处理状态 */
    error: ReportError /* 报告错误类型 */
    examinerAccountId?: number /* 检测者ID */
    examineeAccountId?: number /* 被检测者ID */
    ticket?: string /* 报告唯一uuid */
    valid: boolean /* 有效性 */
    code?: string /* 错误码 */
    message?: string /* 错误信息 */
    footShape: FootShape /* 脚型数据 */
    footPressure: FootPressure /* 静态足压数据 */
    comprehensiveScore: ComprehensiveScore /* 综合分数 */
    shoesCustomization: ShoesCustomization /* 鞋款定制化 */
    examinationReportId?: number /* 报告ID */
    creationTimestamp: number /* 创建时间 */
    updateTimestamp: number /* 更新时间 */
    footShapeValid: boolean
    footShapeCode?: string
    footShapeMessage?: string
    footPressureValid: boolean
    footPressureCode?: string
    footPressureMessage?: string
    remark?: string /* 备注 */
    examinee: Examinee /* 报告的被检测者 */
}

/* 解决方案 */
export interface Solution {
    title: string /* 标题 */
    content: string /* 内容 */
    note: string /* 要点 */
}

export interface GetReportByTicketRequest {
    ticket?: string
}

export interface UploadModelDataRequest {
    ticket?: string /* 报告唯一凭证 */
    leftUrl?: string /* 左脚3D模型url */
    rightUrl?: string /* 右脚3D模型url */
    type: FileType
}

export interface UploadMeasurementDataRequest {
    storeId?: number /* 登录账号所在的storeId店铺ID */
    serialNumber?: string /* 设备序列号 */
    error: ReportError /* 报告错误类型 */
    ticket?: string /* 报告唯一uuid */
    valid: boolean /* 有效性 */
    code?: string /* 错误码 */
    message?: string /* 错误信息 */
    left: Data /* 左脚数据 */
    right: Data /* 右脚数据 */
    pressureDataUrl?: string /* 足压数据 */
    algorithm3DVersion: string /* 点云融合算法版本 */
    algorithmMeasurementVersion: string /* 测量算法版本 */
}

export interface Data {
    footLength: FloatValue /* 脚长 */
    treadLength: FloatValue /* 着地点长 */
    footWidth: FloatValue /* 水平脚宽 */
    toeWidth: FloatValue /* 水平趾宽 */
    heelWidth: FloatValue /* 踵心全宽 */
    medialMPJLength: FloatValue /* 第一跖趾长 */
    lateralMPJLength: FloatValue /* 第五跖趾长 */
    heelLength: FloatValue /* 踵心长 */
    maximumFootWidth: FloatValue /* 最大脚宽 */
    obliqueToeWidth: FloatValue /* 斜趾宽 */
    obliqueFootWidth: FloatValue /* 斜脚宽 */
    toeDepth: FloatValue /* 脚趾厚度 */
    mPJHeight: FloatValue /* 跖趾高 */
    instepHeight: FloatValue /* 跗骨高（脚背高） */
    ballGirth: FloatValue /* 跖趾围长 */
    waistGirth: FloatValue /* 腰围 */
    instepGirth: FloatValue /* 跗围 */
    angleOfMPJWidth: FloatValue /* 斜脚宽角 */
    angleOfToeWidth: FloatValue /* 斜趾宽角 */
    hg: FloatValue /* 兜跟围「Heel girth」 */
    widInnerBigToe: FloatValue /* 拇指里宽「Inner width of big toe 」 */
    widOuterLittleToe: FloatValue /* 小指外宽「Outer width of little toe」 */
    widInnerMPJ1: FloatValue /* 第一跖趾里宽「1st meta-phal inner width」 */
    widOuterMPJ5: FloatValue /* 第五跖趾外宽「5th meta-phal outer width」 */
    widOuterWaist: FloatValue /* 腰窝外宽「Outer width of waist」 */
    lenBigToeContact: FloatValue /* 拇指外凸点部位长「Length of big toe contact point」 */
    lenLittleToeContact: FloatValue /* 小趾外凸点部位长「Length of little toe contact point」 */
    lenWaistPt: FloatValue /* 腰窝部位长度「Length of waist point」 */
    lenPrint: FloatValue /* 脚印长度「Print length」 */
    heigHeel: FloatValue /* 后跟凸点高度「Heel point height」 */
    roomHeel: FloatValue /* 后容差「Room around heel」 */
    lenInstepPt: FloatValue /* 跗骨部位长度「Length of instep point」 */
    angHallux: FloatValue /* 拇趾翻转角度「Hallux angle」 */
    lenToeTip1: FloatValue /* 第一趾端点长度「Length of big toe tip」 */
    lenToeTip2: FloatValue /* 第二趾端点长度「Length of second toe tip」 */
    lenToeTip5: FloatValue /* 第五趾端点长度「Length of little toe tip」 */
    fwPct: FloatValue /* 水平脚宽 %「Foot width %」 */
    fwObliquePct: FloatValue /* 斜脚宽 %「Oblique foot width %」 */
    widInnerMPJ1Pct: FloatValue /* 第一跖趾里宽 %「1st meta-phal inner width %」 */
    widOuterMPJ5Pct: FloatValue /* 第五跖趾外宽 %「5th meta-phal outer width %」 */
    twPct: FloatValue /* 水平趾宽 %「Toe width %」 */
    widOblToePct: FloatValue /* 斜趾宽 %「Oblique toe width %」 */
    widInnerBigToePct: FloatValue /* 拇指里宽 %「Inner width of big toe %」 */
    widOuterLittleToePct: FloatValue /* 小指外宽 %「Outer width of little toe %」 */
    lenMPJ1Pct: FloatValue /* 第一跖趾长 %「Medial MPJ length %」 */
    lenMPJ5Pct: FloatValue /* 第五跖趾长 %「Lateral MPJ length %」 */
    lenBigToeContactPct: FloatValue /* 拇指外凸点部位长 %「Length of big toe contact point %」 */
    lenLittleToeContactPct: FloatValue /* 小趾外凸点部位长 %「Length of little toe contact point %」 */
    lenTreadPct: FloatValue /* 着地点长 %「Tread length %」 */
    bgPct: FloatValue /* 跖趾围长 %「Ball girth %」 */
    model3DUrl?: string /* 3D模型url */
}

export interface ShoesCustomization {
    shoeSize: string /* 鞋码 */
    shoeType: ShoeType /* 鞋型 */
    leftInsoleModel: InsoleModel /* 左脚鞋垫模型 */
    rightInsoleModel: InsoleModel /* 右脚鞋垫模型 */
    originModelInsoleData: OriginModelInsoleData /* 报告原始鞋垫模型参数 */
}

export interface ComprehensiveScore {
    mean: FloatValue /* 综合得分 */
    footArchHealth: Score /* 足弓健康度 */
    bodyBalance: Score /* 身体平衡性 */
    footShape: Score /* 脚型比例 */
    heelVarus: Score /* 足跟内外翻 */
    footPressure: Score /* 左右脚压力 */
}

export interface Score {
    standard: FloatValue /* 标准分数 */
    actual: FloatValue /* 实际报告该项得分 */
    value: FloatValue /* 实际值 */
}

export interface FootShape {
    left: FootShapeData /* 左脚脚型数据 */
    right: FootShapeData /* 右脚脚型数据 */
    bigAndSmallOfFeet: BigAndSmallOfFeet /* 大小脚 */
}

export interface BigAndSmallOfFeet {
    widthAbsDiff: number /* 左右脚脚宽差值绝对值 */
    lengthAbsDiff: number /* 左右脚脚长差值绝对值 */
    level: BigAndSmallOfFeetLevel /* 大小脚数据 */
}

export interface FootPressure {
    valid: boolean /* 有效性 */
    code?: string /* 错误码 */
    message?: string /* 错误信息 */
    thumbnailUrl: string /* 足压彩虹图以及图上相关点坐标 */
    left: FootPressureDataBySide
    right: FootPressureDataBySide
    cop: Cop
}

export interface FootShapeData {
    footLength: FloatValue /* 脚长 */
    treadLength: FloatValue /* 着地点长 */
    footWidth: FloatValue /* 水平脚宽 */
    toeWidth: FloatValue /* 水平趾宽 */
    heelWidth: FloatValue /* 踵心全宽 */
    medialMPJLength: FloatValue /* 第一跖趾长 */
    lateralMPJLength: FloatValue /* 第五跖趾长 */
    heelLength: FloatValue /* 踵心长 */
    maximumFootWidth: FloatValue /* 最大脚宽 */
    obliqueToeWidth: FloatValue /* 斜趾宽 */
    obliqueFootWidth: FloatValue /* 斜脚宽 */
    toeDepth: FloatValue /* 脚趾厚度 */
    mPJHeight: FloatValue /* 跖趾高 */
    instepHeight: FloatValue /* 跗骨高（脚背高） */
    ballGirth: FloatValue /* 跖趾围长 */
    waistGirth: FloatValue /* 腰围 */
    instepGirth: FloatValue /* 跗围 */
    angleOfMPJWidth: FloatValue /* 斜脚宽角 // 足弓高度 */
    angleOfToeWidth: FloatValue /* 斜趾宽角 // 脚后跟内/外旋角度（与Z轴的夹角）, 角度大于０，外旋，角度小于０，内旋 */
    hg: FloatValue /* 兜跟围「Heel girth」 */
    widInnerBigToe: FloatValue /* 拇指里宽「Inner width of big toe 」 */
    widOuterLittleToe: FloatValue /* 小指外宽「Outer width of little toe」 */
    widInnerMPJ1: FloatValue /* 第一跖趾里宽「1st meta-phal inner width」 */
    widOuterMPJ5: FloatValue /* 第五跖趾外宽「5th meta-phal outer width」 */
    widOuterWaist: FloatValue /* 腰窝外宽「Outer width of waist」 */
    lenBigToeContact: FloatValue /* 拇指外凸点部位长「Length of big toe contact point」 */
    lenLittleToeContact: FloatValue /* 小趾外凸点部位长「Length of little toe contact point」 */
    lenWaistPt: FloatValue /* 腰窝部位长度「Length of waist point」 */
    lenPrint: FloatValue /* 脚印长度「Print length」 */
    heigHeel: FloatValue /* 后跟凸点高度「Heel point height」 */
    roomHeel: FloatValue /* 后容差「Room around heel」 */
    lenInstepPt: FloatValue /* 跗骨部位长度「Length of instep point」 */
    angHallux: FloatValue /* 拇趾翻转角度「Hallux angle」 */
    lenToeTip1: FloatValue /* 第一趾端点长度「Length of big toe tip」 */
    lenToeTip2: FloatValue /* 第二趾端点长度「Length of second toe tip」 */
    lenToeTip5: FloatValue /* 第五趾端点长度「Length of little toe tip」 */
    fwPct: FloatValue /* 水平脚宽 %「Foot width %」 */
    fwObliquePct: FloatValue /* 斜脚宽 %「Oblique foot width %」 */
    widInnerMPJ1Pct: FloatValue /* 第一跖趾里宽 %「1st meta-phal inner width %」 */
    widOuterMPJ5Pct: FloatValue /* 第五跖趾外宽 %「5th meta-phal outer width %」 */
    twPct: FloatValue /* 水平趾宽 %「Toe width %」 */
    widOblToePct: FloatValue /* 斜趾宽 %「Oblique toe width %」 */
    widInnerBigToePct: FloatValue /* 拇指里宽 %「Inner width of big toe %」 */
    widOuterLittleToePct: FloatValue /* 小指外宽 %「Outer width of little toe %」 */
    lenMPJ1Pct: FloatValue /* 第一跖趾长 %「Medial MPJ length %」 */
    lenMPJ5Pct: FloatValue /* 第五跖趾长 %「Lateral MPJ length %」 */
    lenBigToeContactPct: FloatValue /* 拇指外凸点部位长 %「Length of big toe contact point %」 */
    lenLittleToeContactPct: FloatValue /* 小趾外凸点部位长 %「Length of little toe contact point %」 */
    lenTreadPct: FloatValue /* 着地点长 %「Tread length %」 */
    bgPct: FloatValue /* 跖趾围长 %「Ball girth %」 */
    model3DUrl?: string /* 3D模型的url */
    footType: FootType /* 脚趾形状 */
    hallexValgusLevel: HallexValgusLevel /* 脚拇指内外翻情况 */
    footWidthLevel: FootWidthLevel /* 脚的宽窄程度 */
    footHeightLevel: FootHeightLevel /* 脚的高矮程度 */
    footWidthValue: FloatValue /* 脚的宽窄系数 */
    angleOfVarus: FloatValue /* 内外翻角度 */
}

export interface OriginModelInsoleData {
    left: Data
    right: Data
}

export interface Data {
    medialLongitudinalArchHigh: MedialLongitudinalArchHigh /* 内足弓高度 */
    medialLongitudinalArchPosition: MedialLongitudinalArchPosition /* 内足弓位置 */
    inEvertion: InEvertion /* 内外翻 */
    length?: number /* 鞋垫长度 */
}

export interface FootPressureDataBySide {
    footArch: FootArch /* 足弓类型 */
    varus: Varus /* 内外翻情况 */
    thumbnailUrl: string /* 缩略图 */
    loadOverBothSide: number /* 单脚压力和全脚压力的比值 */
}

export interface Varus {
    varusType: VarusType /* 内外翻类型 */
    rearOuterValue: number /* 外侧压力比值 */
    rearInnerValue: number /* 内侧压力比值 */
    solutions: Array<Solution> /* 解决方案 */
}

export interface FootArch {
    value: number /* 足弓值 */
    level: FootArchLevel /* 严重程度 */
    solutions: Array<Solution>
}

export interface Cop {
    x: Array<number>
    y: Array<number>
    centroidX: number
    centroidY: number
    ellipse: CopEllipse
    physicalWidth: number
    physicalHeight: number
}

export interface CopEllipse {
    centerX: number
    centerY: number
    radiusX: number
    radiusY: number
    rotate: number /* 旋转弧度值 */
    eccentricity: number /* 偏心率 */
    area: number
}

export interface Data {
    footLength: FloatValue /* 脚长 */
    treadLength: FloatValue /* 着地点长 */
    footWidth: FloatValue /* 水平脚宽 */
    toeWidth: FloatValue /* 水平趾宽 */
    heelWidth: FloatValue /* 踵心全宽 */
    medialMPJLength: FloatValue /* 第一跖趾长 */
    lateralMPJLength: FloatValue /* 第五跖趾长 */
    heelLength: FloatValue /* 踵心长 */
    maximumFootWidth: FloatValue /* 最大脚宽 */
    obliqueToeWidth: FloatValue /* 斜趾宽 */
    obliqueFootWidth: FloatValue /* 斜脚宽 */
    toeDepth: FloatValue /* 脚趾厚度 */
    mPJHeight: FloatValue /* 跖趾高 */
    instepHeight: FloatValue /* 跗骨高（脚背高） */
    ballGirth: FloatValue /* 跖趾围长 */
    waistGirth: FloatValue /* 腰围 */
    instepGirth: FloatValue /* 跗围 */
    angleOfMPJWidth: FloatValue /* 斜脚宽角 */
    angleOfToeWidth: FloatValue /* 斜趾宽角 */
    hg: FloatValue /* 兜跟围「Heel girth」 */
    widInnerBigToe: FloatValue /* 拇指里宽「Inner width of big toe 」 */
    widOuterLittleToe: FloatValue /* 小指外宽「Outer width of little toe」 */
    widInnerMPJ1: FloatValue /* 第一跖趾里宽「1st meta-phal inner width」 */
    widOuterMPJ5: FloatValue /* 第五跖趾外宽「5th meta-phal outer width」 */
    widOuterWaist: FloatValue /* 腰窝外宽「Outer width of waist」 */
    lenBigToeContact: FloatValue /* 拇指外凸点部位长「Length of big toe contact point」 */
    lenLittleToeContact: FloatValue /* 小趾外凸点部位长「Length of little toe contact point」 */
    lenWaistPt: FloatValue /* 腰窝部位长度「Length of waist point」 */
    lenPrint: FloatValue /* 脚印长度「Print length」 */
    heigHeel: FloatValue /* 后跟凸点高度「Heel point height」 */
    roomHeel: FloatValue /* 后容差「Room around heel」 */
    lenInstepPt: FloatValue /* 跗骨部位长度「Length of instep point」 */
    angHallux: FloatValue /* 拇趾翻转角度「Hallux angle」 */
    lenToeTip1: FloatValue /* 第一趾端点长度「Length of big toe tip」 */
    lenToeTip2: FloatValue /* 第二趾端点长度「Length of second toe tip」 */
    lenToeTip5: FloatValue /* 第五趾端点长度「Length of little toe tip」 */
    fwPct: FloatValue /* 水平脚宽 %「Foot width %」 */
    fwObliquePct: FloatValue /* 斜脚宽 %「Oblique foot width %」 */
    widInnerMPJ1Pct: FloatValue /* 第一跖趾里宽 %「1st meta-phal inner width %」 */
    widOuterMPJ5Pct: FloatValue /* 第五跖趾外宽 %「5th meta-phal outer width %」 */
    twPct: FloatValue /* 水平趾宽 %「Toe width %」 */
    widOblToePct: FloatValue /* 斜趾宽 %「Oblique toe width %」 */
    widInnerBigToePct: FloatValue /* 拇指里宽 %「Inner width of big toe %」 */
    widOuterLittleToePct: FloatValue /* 小指外宽 %「Outer width of little toe %」 */
    lenMPJ1Pct: FloatValue /* 第一跖趾长 %「Medial MPJ length %」 */
    lenMPJ5Pct: FloatValue /* 第五跖趾长 %「Lateral MPJ length %」 */
    lenBigToeContactPct: FloatValue /* 拇指外凸点部位长 %「Length of big toe contact point %」 */
    lenLittleToeContactPct: FloatValue /* 小趾外凸点部位长 %「Length of little toe contact point %」 */
    lenTreadPct: FloatValue /* 着地点长 %「Tread length %」 */
    bgPct: FloatValue /* 跖趾围长 %「Ball girth %」 */
}

export enum Sex {
    SEX_UNKNOWN = 0,
    SEX_FEMALE = 1,
    SEX_MALE = 2,
}

export enum Order {
    ORDER_DESC = 0,
    ORDER_ASC = 1,
}

export enum OrganizationType {
    ORGANIZATION_TYPE_UNKNOWN = 0,
    ORGANIZATION_TYPE_SENNOTECH_INSTITUTION = 1, /* 创感机构 */
    ORGANIZATION_TYPE_SENNOTECH_STORE = 2, /* 创感店铺 */
    ORGANIZATION_TYPE_HIMALAYA_INSTITUTION = 3, /* 喜马拉雅机构 */
    ORGANIZATION_TYPE_HIMALAYA_STORE = 4, /* 喜马拉雅店铺 */
}

export enum FootSide {
    FOOT_SIDE_UNKNOWN = 0,
    LEFT = 1,
    RIGHT = 2,
}

/* 内足弓高度 */
export enum MedialLongitudinalArchHigh {
    MEDIAL_LONGITUDINAL_ARCH_HIGH_UNKNOWN = 0,
    A_MINUS_100 = 1, /* A-100 */
    A0 = 3, /* A0 */
    A_PLUS_100 = 5, /* A+100 */
}

/* 内足弓位置 */
export enum MedialLongitudinalArchPosition {
    MEDIAL_LONGITUDINAL_ARCH_POSITION_UNKNOWN = 0,
    B_MINUS_100 = 1, /* B-100 */
    B0 = 3, /* B0 */
    B_PLUS_100 = 5, /* B+100 */
}

/* 内外翻 */
export enum InEvertion {
    IN_EVERTION_UNKNOWN = 0,
    D_MINUS_100 = 1, /* D-100 */
    D_MINUS_50 = 2, /* D-50 */
    D0 = 3, /* D0 */
    D_PLUS_50 = 4, /* D50 */
    D_PLUS_100 = 5, /* D100 */
}

export enum UrlType {
    URL_TYPE_UNKNOWN = 0,
    RESOURCE_PATH = 1, /* 直接资源路径 */
    QR_CODE = 2, /* 二维码 */
}

export enum Scene {
    SCENE_UNKNOWN = 0,
    AFTER_MEASUREMENT = 1, /* 检测后 */
    AFTER_REGISTRATION = 2, /* 注册后 */
}

export enum VersionType {
    VERSION_TYPE_UNKNOWN = 0,
    DESKTOP_CORE = 1, /* 上位机软件 */
    DESKTOP_CONFIG = 2, /* 上位机配网软件 */
}

export enum DeviceStatus {
    ONLINE = 0,
    OFFLINE = 1,
}

export enum CosStsCredentialType {
    COS_STS_CREDENTIAL_TYPE_UNKNOWN = 0,
    REPORT_DATA = 1, /* 报告数据 */
    UPGRADE_PACKAGE = 2, /* 升级包 */
    INSOLE_MODEL = 3, /* 鞋垫模型存储 */
}

export enum ActivationCodeConsumedStatus {
    NOT_CONSUMED = 0,
    HAS_CONSUMED = 1,
}

export enum ReceiverType {
    UNKNOWN = 0,
    ACCOUNT = 1, /* 个人账号 */
    ORGANIZATION = 2, /* 组织账号 */
}

export enum ProcessingState {
    NULL = 0,
    COLLECTING = 1, /* 数据采集中 */
    PROCESSING = 2, /* 处理中 */
    COMPLETED = 3, /* 处理完成 */
}

export enum FootType {
    FOOT_TYPE_UNKNOWN = 0,
    GREEK = 1, /* 希腊脚 */
    ROMAN = 2, /* 罗马脚 */
    EGYPTIAN = 3, /* 埃及脚 */
}

export enum FileType {
    FILE_TYPE_UNKNOWN = 0,
    FILE_TYPE_STL = 1,
    FILE_TYPE_ZIP = 2,
}

export enum ReportError {
    REPORT_ERROR_NULL = 0, /* 无 */
    REPORT_ERROR_UNKNOWN = 1, /* 未知错误 */
    REPORT_ERROR_TIMEOUT = 2, /* 上传超时（目前定为10分钟若一体机未上传数据则认为超时） */
    REPORT_ERROR_DEVICE_MOTOR = 6, /* 电机异常 */
    REPORT_ERROR_DEVICE_CAMERA = 7, /* 相机异常 */
    REPORT_ERROR_DEVICE_PRESSURE = 8, /* 压力传感器异常 */
    REPORT_ERROR_MODEL_COLLECTING = 12, /* 3D模型建模失败 */
    REPORT_ERROR_MODEL_PROCESSING = 13, /* 3D模型测量失败 */
    REPORT_ERROR_PRESSURE_COLLECTING = 16, /* 压力采集失败 */
    REPORT_ERROR_PRESSURE_PROCESSING = 17, /* 压力处理失败 */
    REPORT_ERROR_DATA_FILE_UPLOADING = 21, /* 数据文件上传失败 */
}

export enum ResType {
    RES_TYPE_UNKNOWN = 0,
    RES_TYPE_RESOURCE_PATH = 1, /* 资源路径 */
    RES_TYPE_IMAGE_PAGE = 2, /* 页面图片URL */
    RES_TYPE_IMAGE_QRCODE = 3, /* 二维码图片URL */
}

export enum ReqMethod {
    REQ_METHOD_UNKNOWN = 0,
    REQ_METHOD_GET = 1,
    REQ_METHOD_POST = 2,
}

export enum ReqScene {
    REQ_SCENE_UNKNOWN = 0,
    REQ_SCENE_SMS_REGISTRATION = 1, /* 短信注册 */
    REQ_SCENE_SMS_VERIFICATION = 2, /* 短信验证 */
    REQ_SCENE_REPORT_VIEWER_AFTER_MEASUREMENT = 3, /* 检测后获取报告视图 */
    REQ_SCENE_REPORT_VIEWER_AFTER_REGISTRATION = 4, /* 注册后获取报告视图 */
    REQ_SCENE_REPORT_COMPLETION_NOTIFICATION = 5, /* 报告完成通知 */
}

export enum Type {
    TYPE_UNKNOWN = 0,
    TYPE_HTML = 1, /* HTML */
    TYPE_IMAGE_PAGE = 2, /* 报告结果页图片 */
    TYPE_IMAGE_QRCODE = 3, /* 跳转报告页的二维码图片 */
}

export enum ShoeType {
    SHOE_TYPE_UNKNOWN = 0,
    BUFFER_SHOCK_ABSORPTION = 1, /* 缓冲减震型 */
    SUPPORT = 2, /* 支撑型 */
}

export enum FootHeightLevel {
    FOOT_HEIGHT_LEVEL_UNKNOWN = 0,
    HIGH_SEVERE = 1, /* 很高 */
    HIGH_MILD = 2, /* 偏高 */
    FOOT_HEIGHT_LEVEL_NORMAL = 3, /* 正常 */
    SHORT_MILD = 4, /* 偏矮 */
    SHORT_SEVERE = 5, /* 很矮 */
}

export enum FootWidthLevel {
    FOOT_WIDTH_LEVEL_UNKNOWN = 0,
    NARROW_SEVERE = 1, /* 很窄 */
    NARROW_MILD = 2, /* 偏窄 */
    FOOT_WIDTH_LEVEL_NORMAL = 3, /* 正常 */
    WIDE_MILD = 4, /* 偏宽 */
    WIDE_SEVERE = 5, /* 很宽 */
}

export enum HallexValgusLevel {
    HALLEX_VALGUS_LEVEL_UNKNOWN = 0,
    HALLUX_VARUS_SERVER = 1, /* 重度拇内翻 */
    HALLUX_VARUS_MILD = 2, /* 轻度拇内翻 */
    HALLEX_VALGUS_LEVEL_NORMAL = 3, /* 正常脚 */
    HALLEX_VALGUS_MILD = 4, /* 轻度拇外翻 */
    HALLEX_VALGUS_SEVERE = 5, /* 重度拇外翻 */
}

export enum BigAndSmallOfFeetLevel {
    BIG_AND_SMALL_OF_FEET_LEVEL_UNKNOWN = 0,
    BIG_AND_SMALL_OF_FEET_LEVEL_NORMAL = 1, /* 正常 */
    MILD = 2, /* 两脚有区别 */
    SEVERE = 3, /* 大小脚 */
}

/* 内外翻 */
export enum VarusType {
    VARUS_TYPE_UNKNOWN = 0,
    VARUS_TYPE_VARUS = 1, /* 足内翻 */
    VARUS_TYPE_VALGUS = 2, /* 足外翻 */
    VARUS_TYPE_NORMAL = 3, /* 正常 */
    VARUS_TYPE_VARUS_MILD = 4, /* 轻度后足内翻 */
    VARUS_TYPE_VALGUS_MILD = 5, /* 轻度后足外翻 */
}

export enum FootArchLevel {
    FOOT_ARCH_LEVEL_UNKNOWN = 0,
    HIGH_SEVERE = 1, /* 重度高足弓 */
    HIGH = 2, /* 高足弓 */
    HIGH_MILD = 3, /* 轻度高足弓 */
    NORMAL = 4, /* 中足弓 */
    FLAT_MILD = 5, /* 轻度扁平足 */
    FLAT = 6, /* 扁平足 */
    FLAT_SEVERE = 7, /* 重度扁平足 */
}

export class ScannerService extends GrpcService {
    constructor(host: string, httpRequestDelegate: HttpRequestDelegate) {
        super(host, httpRequestDelegate)
    }
    
    /* region examinee
 根据accountID查看被检测者列表 */
    async listExamineeByAccountId(request: ListExamineeByAccountIdRequest): Promise<ListExamineeByAccountIdResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/ListExamineeByAccountId"
        return await this.call(method, path, request) as ListExamineeByAccountIdResponse
    }
    
    /* 添加被检测者信息 */
    async addExaminee(request: AddExamineeRequest): Promise<AddExamineeResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/AddExaminee"
        return await this.call(method, path, request) as AddExamineeResponse
    }
    
    /* 修改被检测者信息「注意需要把没修改的也带回来」 */
    async updateExaminee(request: UpdateExamineeRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/scanner.ScannerService/UpdateExaminee"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* region report
 创建一个空头报告（需要登陆，即请求头里带"senno-access-token=登录时返回的access token"）） */
    async createReport(request: CreateReportRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/scanner.ScannerService/CreateReport"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* 上传报告测量数据（需要登陆，即请求头里带"senno-access-token=登录时返回的access token"）） */
    async uploadMeasurementData(request: UploadMeasurementDataRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/scanner.ScannerService/UploadMeasurementData"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* 上传报告3d脚模型数据 */
    async uploadModelData(request: UploadModelDataRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/scanner.ScannerService/UploadModelData"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* 根据ticket获取报告结果 */
    async getReportByTicket(request: GetReportByTicketRequest): Promise<GetReportByTicketResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/GetReportByTicket"
        return await this.call(method, path, request) as GetReportByTicketResponse
    }
    
    /* 报告关联被检测者 */
    async bindingReportExaminee(request: BindingReportExamineeRequest): Promise<BindingReportExamineeResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/BindingReportExaminee"
        return await this.call(method, path, request) as BindingReportExamineeResponse
    }
    
    /* 查看报告是否绑定了被检测者 */
    async checkReportExamineeExist(request: CheckReportExamineeExistRequest): Promise<CheckReportExamineeExistResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/CheckReportExamineeExist"
        return await this.call(method, path, request) as CheckReportExamineeExistResponse
    }
    
    /* 查看报告的被检测者 */
    async getReportExamineeAccountIdByTicket(request: GetReportExamineeAccountIdByTicketRequest): Promise<GetReportExamineeAccountIdByTicketResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/GetReportExamineeAccountIdByTicket"
        return await this.call(method, path, request) as GetReportExamineeAccountIdByTicketResponse
    }
    
    /* 获取认领足部报告路径 TODO 接口已过时 */
    async claimReport(request: ClaimReportRequest): Promise<ClaimReportResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/ClaimReport"
        return await this.call(method, path, request) as ClaimReportResponse
    }
    
    /* 获取报告列表 */
    async listReport(request: ListReportRequest): Promise<ListReportResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/ListReport"
        return await this.call(method, path, request) as ListReportResponse
    }
    
    async pageListReport(request: PageListReportRequest): Promise<PageListReportResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/PageListReport"
        return await this.call(method, path, request) as PageListReportResponse
    }
    
    /* 刷新报告状态 */
    async refreshReport(request: RefreshReportRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/scanner.ScannerService/RefreshReport"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* 为报告新增备注 */
    async addReportRemark(request: AddReportRemarkRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/scanner.ScannerService/AddReportRemark"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* 修改报告备注 */
    async updateReportRemark(request: UpdateReportRemarkRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/scanner.ScannerService/UpdateReportRemark"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* 删除报告备注 */
    async deleteReportRemark(request: DeleteReportRemarkRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/scanner.ScannerService/DeleteReportRemark"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* TODO 这是一个等待删除的旧接口，被「UploadMeasurementData」「UploadModelData」取代
 上传报告数据（需要登陆，即请求头里带"senno-access-token=登录时返回的access token"）） */
    async uploadReport(request: UploadReportRequest): Promise<UploadReportResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/UploadReport"
        return await this.call(method, path, request) as UploadReportResponse
    }
    
    /* 获取报告详情列表 */
    async pageListReportAndExaminee(request: PageListReportAndExamineeRequest): Promise<PageListReportAndExamineeResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/PageListReportAndExaminee"
        return await this.call(method, path, request) as PageListReportAndExamineeResponse
    }
    
    /* 根据报告ticket获取报告结果页面(渲染好的结果图片（或跳转到报告结果页的二维码图片）、html) */
    async viewReport(request: ViewReportRequest): Promise<ViewReportResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/ViewReport"
        return await this.call(method, path, request) as ViewReportResponse
    }
    
    /* 添加压力子报告项（平衡｜静态｜动态）处理完成回调 */
    async reportDataProcessedNotification(request: ReportDataProcessedNotificationRequest): Promise<ReportDataProcessedNotificationResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/ReportDataProcessedNotification"
        return await this.call(method, path, request) as ReportDataProcessedNotificationResponse
    }
    
    /* region mesh 简化网格回调 */
    async simplifyMeshNotification(request: SimplifyMeshNotificationRequest): Promise<SimplifyMeshNotificationResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/SimplifyMeshNotification"
        return await this.call(method, path, request) as SimplifyMeshNotificationResponse
    }
    
    /* region license
 获取扫脚仪license列表 */
    async listLicense(request: ListLicenseRequest): Promise<ListLicenseResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/ListLicense"
        return await this.call(method, path, request) as ListLicenseResponse
    }
    
    /* 创建分发器（为某个组织发放分发器，需要accessToken->需要记录是谁发放的） */
    async createLicenseDistributor(request: CreateLicenseDistributorRequest): Promise<CreateLicenseDistributorResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/CreateLicenseDistributor"
        return await this.call(method, path, request) as CreateLicenseDistributorResponse
    }
    
    /* 根据组织ID获取激活码分发器列表 */
    async listLicenseDistributor(request: ListLicenseDistributorRequest): Promise<ListLicenseDistributorResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/ListLicenseDistributor"
        return await this.call(method, path, request) as ListLicenseDistributorResponse
    }
    
    /* 分发激活码给指定组织ID或个人（需要accessToken，因为要记录是谁分发出去的） */
    async generateActivationCodeList2Organization(request: GenerateActivationCodeList2OrganizationRequest): Promise<GenerateActivationCodeList2OrganizationResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/GenerateActivationCodeList2Organization"
        return await this.call(method, path, request) as GenerateActivationCodeList2OrganizationResponse
    }
    
    /* 根据组织ID获取已发放的激活码 */
    async listActivationCodeInfoByOrganizationId(request: ListActivationCodeInfoByOrganizationIdRequest): Promise<ListActivationCodeInfoByOrganizationIdResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/ListActivationCodeInfoByOrganizationId"
        return await this.call(method, path, request) as ListActivationCodeInfoByOrganizationIdResponse
    }
    
    /* 激活（必须要设备序列号，根据code核销，需要accessToken，保存是谁激活） */
    async activate(request: ActivateRequest): Promise<ActivateResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/Activate"
        return await this.call(method, path, request) as ActivateResponse
    }
    
    /* region device
 查看某个组织下已经发放的设备信息 */
    async listDeviceInfoByOrganizationId(request: ListDeviceInfoByOrganizationIdRequest): Promise<ListDeviceInfoByOrganizationIdResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/ListDeviceInfoByOrganizationId"
        return await this.call(method, path, request) as ListDeviceInfoByOrganizationIdResponse
    }
    
    /* 吊销设备deactive（需要accessToken） */
    async deactiveDeviceInfo(request: DeactiveDeviceInfoRequest): Promise<DeactiveDeviceInfoResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/DeactiveDeviceInfo"
        return await this.call(method, path, request) as DeactiveDeviceInfoResponse
    }
    
    /* 查看设备状态 */
    async getDeviceInfo(request: GetDeviceInfoRequest): Promise<GetDeviceInfoResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/GetDeviceInfo"
        return await this.call(method, path, request) as GetDeviceInfoResponse
    }
    
    /* region cos
 获取cos临时密钥 */
    async getCosStsCredential(request: GetCosStsCredentialRequest): Promise<GetCosStsCredentialResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/GetCosStsCredential"
        return await this.call(method, path, request) as GetCosStsCredentialResponse
    }
    
    /* region organization
 获取用户所在的店铺信息（需要登录，即请求头里带"senno-access-token=登录时返回的access token"） */
    async listStore(request: ListStoreRequest): Promise<ListStoreResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/ListStore"
        return await this.call(method, path, request) as ListStoreResponse
    }
    
    /* 根据店铺ID获取机构信息 */
    async getInstitutionByStoreId(request: GetInstitutionByStoreIdRequest): Promise<GetInstitutionByStoreIdResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/GetInstitutionByStoreId"
        return await this.call(method, path, request) as GetInstitutionByStoreIdResponse
    }
    
    /* 为组织分配权限（使用起始结束时间） */
    async updateOrganizationLicence(request: UpdateOrganizationLicenceRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/scanner.ScannerService/UpdateOrganizationLicence"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* 查看组织license */
    async listOrganizationLicence(request: ListOrganizationLicenceRequest): Promise<ListOrganizationLicenceResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/ListOrganizationLicence"
        return await this.call(method, path, request) as ListOrganizationLicenceResponse
    }
    
    /* 添加组织api(一个组织ID在一个使用场景只能有一条数据) */
    async addOrganizationApi(request: OrganizationApi): Promise<OperateResult> {
        const method = "post"
        const path = "/scanner.ScannerService/AddOrganizationApi"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* region version
 新增版本信息 */
    async addVersionInfo(request: AddVersionInfoRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/scanner.ScannerService/AddVersionInfo"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* 更新版本信息 */
    async updateVersionInfo(request: UpdateVersionInfoRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/scanner.ScannerService/UpdateVersionInfo"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* 获取根据版本类型获取最新版本信息 */
    async getLatestVersionInfoByType(request: GetLatestVersionInfoByTypeRequest): Promise<GetLatestVersionInfoByTypeResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/GetLatestVersionInfoByType"
        return await this.call(method, path, request) as GetLatestVersionInfoByTypeResponse
    }
    
    /* region http get */
    async generateReportQRCode(request: GenerateReportQRCodeRequest): Promise<GenerateReportQRCodeResponse> {
        const method = "get"
        const path = "/scanner.ScannerService/GenerateReportQRCode"
        return await this.call(method, path, request) as GenerateReportQRCodeResponse
    }
    
    async getExamineeRegisterUrl(request: GetExamineeRegisterUrlRequest): Promise<GetExamineeRegisterUrlResponse> {
        const method = "get"
        const path = "/scanner.ScannerService/GetExamineeRegisterUrl"
        return await this.call(method, path, request) as GetExamineeRegisterUrlResponse
    }
    
    /* region insole model */
    async getInsoleModel(request: GetInsoleModelRequest): Promise<GetInsoleModelResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/GetInsoleModel"
        return await this.call(method, path, request) as GetInsoleModelResponse
    }
    
    /* 修改报告绑定的鞋垫模型「insole model」 */
    async updateReportInsoleModel(request: UpdateReportInsoleModelRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/scanner.ScannerService/UpdateReportInsoleModel"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* list */
    async listInsoleModel(request: ListInsoleModelRequest): Promise<ListInsoleModelResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/ListInsoleModel"
        return await this.call(method, path, request) as ListInsoleModelResponse
    }
    
    /* 分页查看鞋垫模型列表 */
    async pageListInsoleModel(request: PageListInsoleModelRequest): Promise<PageListInsoleModelResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/PageListInsoleModel"
        return await this.call(method, path, request) as PageListInsoleModelResponse
    }
    
    /* 添加鞋垫模型 */
    async addInsoleModel(request: AddInsoleModelRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/scanner.ScannerService/AddInsoleModel"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* region sms notification
 给机构/商户的用户组（角色）添加自主注册的用户，用户通知（note：用户自主注册） */
    async sendSmsNotificationWhenAccountRegistered(request: SendSmsNotificationWhenAccountRegisteredRequest): Promise<OperateResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/SendSmsNotificationWhenAccountRegistered"
        return await this.call(method, path, request) as OperateResponse
    }
    
    /* 给机构/商户的用户组（角色）添加预注册用户，用户通知（note：用户非自主注册，管理员从后台加入） */
    async sendSmsNotificationWhenAccountPreRegistration(request: SendSmsNotificationWhenAccountPreRegistrationRequest): Promise<OperateResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/SendSmsNotificationWhenAccountPreRegistration"
        return await this.call(method, path, request) as OperateResponse
    }
    
    /* 注册发送手机验证码 */
    async sendSmsRegisterCaptcha(request: SendSmsRegisterCaptchaRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/scanner.ScannerService/SendSmsRegisterCaptcha"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* 校验手机验证码 */
    async verifySmsRegisterCaptcha(request: VerifySmsRegisterCaptchaRequest): Promise<VerifySmsRegisterCaptchaResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/VerifySmsRegisterCaptcha"
        return await this.call(method, path, request) as VerifySmsRegisterCaptchaResponse
    }
    
    /* Register */
    async register(request: RegisterRequest): Promise<RegisterResponse> {
        const method = "post"
        const path = "/scanner.ScannerService/Register"
        return await this.call(method, path, request) as RegisterResponse
    }
    
}
